import { Skeleton as MSkeleton, styled } from "@mui/material";
import { transientOptions } from "../styles/theme";

const Skeleton = styled(MSkeleton, transientOptions)`
  border-radius: ${({ _border_ = "0" }) => _border_};
  margin: ${({ _margin_ = "0" }) => _margin_};
`;

export default Skeleton;
